import { ISettings } from '@/contracts/modules/education/entities/ISettings'

/** Настройки опроса: тело PUT settings и ответ GET/PUT settings */
export class Settings implements ISettings {
  period: number
  size: number

  constructor({ period, size }: ISettings) {
    this.period = period
    this.size = size
  }
}
